import { registerLocaleData } from '@angular/common';
import es from '@angular/common/locales/es';
import { Component, OnInit, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import { DetalleUsuarioService } from 'src/app/Services/detalle-usuario.service';
import { ListaEmpresasService } from 'src/app/Services/lista-empresas.service';
import { ParametroAccionService } from 'src/app/Services/parametro-accion.service';
import { ModalCertDdjjFormComponent } from '../modal-cert-ddjj-form/modal-cert-ddjj-form.component';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'cert-ddjj-vp',
  templateUrl: './cert-ddjj-vp.component.html',
  styleUrls: ['./cert-ddjj-vp.component.css']
})
export class CertDdjjVpComponent implements OnInit {
  rutVal:any;
  params: any;
  periodos: any;
  private certDecJur:string = environment.certdecjur;

  constructor(private router: Router, public listaEmprService : ListaEmpresasService, private http: HttpClient, private sanitizer:DomSanitizer, private modalService: NgbModal, public detalleUsuarioService: DetalleUsuarioService, public parametroAccionService:ParametroAccionService) { 
    /****************Valida sesión con RUT*****************/
    this.detalleUsuarioService.getVariableCompartida().subscribe(datos => {
      this.rutVal = datos;
    });
    if (this.rutVal=="0"||this.rutVal==null) {
      //var urlcierre :string="https://accounts.claveunica.gob.cl/api/v1/accounts/app/logout?https%3A%2F%2Faplicaciones.mop.gob.cl%2FTramitesDCyF";
      //var sanitizedValue:string= this.sanitizer.sanitize(SecurityContext.URL,urlcierre);
      //window.location.href=sanitizedValue;
      this.listaEmprService.limpiarDatos();
      this.detalleUsuarioService.limpiarDatos();
      this.detalleUsuarioService.limpiarRut();
      localStorage.clear();
      this.router.navigate(['/inicio']);
      return;
    }
    /****************Fin Valida sesión con RUT*****************/
    this.getDatos();
    
  }

  ngOnInit(): void {
    
    registerLocaleData( es );
  }

  GenerarPDF(){
    const data = document.getElementById('contentToConvert'); // el div que quieres convertir
    if (data) {
      html2canvas(data).then(canvas => {
        const imgWidth = 260;
        const imgHeight = canvas.height * imgWidth / canvas.width;
        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('l', 'mm','a4');
        pdf.addImage(imgData, 'PNG', 10, 10, imgWidth, imgHeight);
        pdf.save("download.pdf");
      });
    }
  }

  getDatos(){
    this.http.post<any>(this.certDecJur, { 
      rut:this.detalleUsuarioService.obtenerRut(),
      ano:this.parametroAccionService.obtenerDatos()
    },{ observe: 'response' }).subscribe((response: HttpResponse<any>) => {
      const statusCode = response.status;
      const responseBody = response.body;
      const respuesta = responseBody.Resultados[0];
      //console.log("llamada insert_repr"+respuesta);
      if (statusCode === 200) {
        //resolve(responseBody);
        //this.parametroAccionService.guardarDatos(respuesta);
        this.params = respuesta;
        console.log(this.params);
        this.periodos = this.params.detalleLineaHonorario;
        console.log(this.periodos);
        
        //this.router.navigate(['/app-cert-ddjj-vp']);
      }else{
        console.log(respuesta);
        //reject(responseBody);
      }
    }, err => {
      console.log("error capturado");
      console.log(err);
      //reject(err);
      //continuar=false;
    });
  }

  openModal(){
    const modalRef =this.modalService.open(ModalCertDdjjFormComponent, {
      backdrop: 'static', // Aquí estableces 'static' como el valor del backdrop
      keyboard: false,     // Esto desactiva la capacidad de cerrar el modal con la tecla Esc
      centered:true
    });
    modalRef.result.then(
      () => {
        // El modal se cerró correctamente
        this.getDatos();
      },
      () => {
        // Se cerró el modal con dismiss
        this.getDatos();
      }
    );
    //eliminar lo siguiente si es modal.
    //this.router.navigate(['/inicio']);
  }
}
